import {useEffect, useRef} from "react";
import {useDrag, useDrop} from "react-dnd";
import {DashboardSettingListElementType} from "../../interface";
import {useUpdateDashboardOrderSetting} from "../../hooks/useUpdateDashboardOrderSetting";
import {useQueryClient} from "@tanstack/react-query";
import {DefaultResType} from "../../../../../../types/common/response";

interface Props {
    order: number
    item: DashboardSettingListElementType
    children: (args: { dragHandleRef: React.RefObject<HTMLDivElement | null> }) => React.ReactNode
}

const ItemType = 'DASHBOARD_CARD'

export default function DraggableCard({order, item, children}: Props) {
    const queryClient = useQueryClient();

    const ref = useRef<HTMLDivElement>(null)
    const dragHandleRef = useRef<HTMLDivElement>(null)

    const apiData = queryClient.getQueriesData<DefaultResType>({queryKey: ['readDashboardSetting']})
    const cardData: any[] = apiData[0]?.[1]?.data?.result.dashboardInfoVOList ?? []

    const {mutate} = useUpdateDashboardOrderSetting()

    const [{isOver}, drop] = useDrop({
        accept: ItemType,
        hover(dragItem: { index: number }, monitor) {
            if (!ref.current || dragItem.index === order) return
            dragItem.index = order
        },
        collect: (monitor) => ({
            isOver: monitor.isOver({shallow: true}),
        }),
        drop(dragItem: any, monitor) {
            if (!monitor.didDrop()) {
                // console.log(`잡은 카드, id:${dragItem.dashboardInfoId}, order:${dragItem.dashboardOrder}`, dragItem)
                // console.log(`타겟 카드, id:${item.dashboardInfoId}, order:${item.dashboardOrder}`, item)

                if (dragItem.dashboardOrder === item.dashboardOrder) {
                    return;
                }

                const list = cardData.map(el => {
                    if (el.dashboardInfoId === dragItem.dashboardInfoId) {
                        return {...el, dashboardOrder: item.dashboardOrder}
                    } else if (el.dashboardInfoId === item.dashboardInfoId) {
                        return {...el, dashboardOrder: dragItem.dashboardOrder}
                    } else return el
                })

                mutate(list)
            }
        }
    })

    const [{isDragging}, drag, dragPreview] = useDrag({
        type: ItemType,
        item: item,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    useEffect(() => {
        if (ref.current) {
            dragPreview(ref)
        }
    }, [ref, dragPreview])

    drop(ref)
    drag(dragHandleRef)

    return (
        <div ref={ref} style={{
            opacity: isDragging ? 0.5 : 1,
            border: isOver ? '1px dashed #007bff' : '1px solid transparent',
            backgroundColor: isOver ? '#f0f8ff' : 'white',
            transition: 'background-color 0.2s, border 0.2s',
        }}>
            {children({dragHandleRef})}
        </div>
    )
}